module.exports = __webpack_public_path__ + "static/media/averta-light.7fc07c60.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/averta-light.woff
// module id = 846
// module chunks = 4